import axios from 'axios'

import env from '../environments'

export async function ping() {
	return axios.get(`${env.chatbotApiUrl}/ping`)
}
